// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3mKBz","clinicsSelect":"TableHeading_clinicsSelect__3fCoU"};